export const travelOnlineLeadsStructure = {
  mcid: "",
  forms: {
    formId: "GetQuickQuote_302",
    formName: "Get+Quick+Quote",
    personalizationId: "",
    name: "",
    emailAddress: "",
    phoneNumber: "",
    employmentInformation: "",
    occupation: "",
    getQuickQuoteForm: {
      componentId: "GetQuickQuote_302",
      productId: "travel_101",
      tenure: "1",
      variantId: "Variant_201",
      sumInsured: "50000",
      familyCombination: "1A",
      ageOfEldestMember: "0",
      zone: "",
      deductible: "",
      personalAccidentOptionalCover: "No",
      personalAccidentSumInsured: "No",
      healthCoachOptionalCover: "No",
      riskClass: "",
      accidentalHospitalization: "No",
      temporaryTotalDisablity: "No",
      criticalIllnessSumInsured: "No",
      hospitalCashSI: "No",
      geography: "",
      hospitalCashFlag: "No",
      modificationInRoomRent: "No",
      coPaymentAmount: "",
      internationalCover: "No",
      isQuoteIdGenerated: "Yes",
      productName: "Travel Assure",
      productType: "",
      criticalIllnessOptionalCover: "No",
      typeOfOccupation: "",
      employmentType: "",
      annualIncome: "",
      isExistingPolicyHolder: "No",
      existingPolicyNumber: "",
      existingPolicyDOB: "",
      addOnsDetails: [],
      enhancedRefill: "No",
      enhancedNCB: "No",
      econsultation: "No",
      premiumWaiver: "No",
      criticalIllnessFlag: "No",
      enhancedLoyalty: "No",
      doubleYourSI: "No",
      personalAccidentFlag: "No",
      safeGuardBenefit: "No",
      safeguardPlusBenefit: "No",
      doctorDiscount: "No",
      noOfMembers: "1",
      planType: "Individual",
      multipleDOBAdult: [],
      multipleDOBChild: [],
      healthCareWorkerFlag: "No",
      covidPositiveQues: "No",
      staffEmail: "",
      staffId: "",
      destination: [],
      noOfDays: "",
      priority: "",
      productVariant: "Plan3",
      tripType:"",
      duration:"",
      startDate:'',
      endDate:'',
    },
    quoteGeneratedDetails: {
      productId: "travel_101",
      basePremium: "",
      premiumBeforeTax: "",
      taxInPercentage: "",
      taxAmount: "",
      premiumAfterTax: "",
      zone: "",
    },
    whatsAppConsent: "Yes",
    dndConsent: "Yes",
    gclid: "",
  },
  geoLocation: {},
  channel: "Retail",
  subChannel: "Website",
  department: "Website",
  subDepartment: "Website",
  lifeTimeSource: "",
  subsequentSources: [],
  browser: "",
  operatingSystem: "",
  campaignId: "",
  internalCampaignId: "",
  utmLeadFields: {
    utmSource: "",
    utmMedium: "",
    utmCampaign: "",
    utmTerm: "",
    utmPara1: "",
    utmPara2: "",
  },
  otpValidated: false,
  ipAddress: "",
  travelChannel: {
    maxbupaBranchCode: "511151",
    maxbupaBranchLocation: "NOC - NOIDA",
    agentID: "NA",
    agentName: "NA",
    salesPersonCode: "000P111042",
    salesPersonName: "Ankur Kharbanda",
    channelType: "Online",
    agentContactNumber: "NA",
  },
  pml: "false",
  dateTime: {
    $date: "",
  },
  month: "",
  year: "",
  _class:
    "com.nivabupa.apiservices.model.personalization.getquickquote.GetYourQuote",
};

export const tempSurrogatePricing={
      "18-35": {
        "5 Lakhs": 22642,
      },
      "36-40": {
        "5 Lakhs": 33963,
      },
      "41-48": {
        "5 Lakhs": 45283,
      },
      "49-65": {
        "5 Lakhs": 67925,
      }
    
  }

  export const tempOcytePricing={
    "18-35": {
      "5 Lakhs": 5042,
    },
    "36-40": {
      "5 Lakhs": 7563,
    },
    "41-48": {
      "5 Lakhs": 10083,
    },
    "49-65": {
      "5 Lakhs": 15125,
    }
  
}